import React from 'react';
import { useNavigate } from "react-router-dom";
import AppFooter from "./AppFooter";
import { FaArrowLeft } from "react-icons/fa";
import entity from "../data/legal/entity.json";

// Renders a legal document from client/src/data/legal/*.json. The same JSON
// is turned into the static server/public/*.html pages by
// scripts/buildLegalHtml.js, so the in-app and public versions can't drift.

const text = { color: "#000" };

// Links open in a new tab so the TermsAcceptanceGate (which embeds the Terms)
// keeps its state.
function Segments({ content }) {
  const segments = Array.isArray(content) ? content : [content];
  return segments.map((seg, i) => {
    if (typeof seg === "string") return <React.Fragment key={i}>{seg}</React.Fragment>;
    if (seg.href) {
      return (
        <a key={i} href={seg.href} target="_blank" rel="noopener noreferrer">
          {seg.text}
        </a>
      );
    }
    if (seg.bold) return <strong key={i}>{seg.text}</strong>;
    if (seg.code) return <code key={i}>{seg.text}</code>;
    return <React.Fragment key={i}>{seg.text}</React.Fragment>;
  });
}

function Section({ section, num }) {
  let sub = 0;
  return (
    <>
      <h2 style={text}>{num}. {section.title}</h2>
      {section.blocks.map((block, i) => {
        if (block.h3) {
          sub += 1;
          return <h3 key={i} style={text}>{num}.{sub} {block.h3}</h3>;
        }
        if (block.ul) {
          return (
            <ul key={i}>
              {block.ul.map((item, j) => (
                <li key={j} style={text}><Segments content={item} /></li>
              ))}
            </ul>
          );
        }
        return <p key={i} style={text}><Segments content={block.p} /></p>;
      })}
    </>
  );
}

function LegalDocument({ doc, className, hideFooter = false }) {
  const navigate = useNavigate();

  return (
    <>
      {/* Desktop inline action bar (replaces footer on desktop) */}
      {!hideFooter && (
        <div className="desktop-action-bar">
          <button type="button" onClick={() => navigate(-1)}>
            <FaArrowLeft /> Back
          </button>
        </div>
      )}

      <div
        className={className}
        style={{
          padding: "2rem",
          maxWidth: "800px",
          margin: "0 auto",
          paddingBottom: "5rem", // extra space for fixed footer
          color: "#000",
          background: "#fff",
        }}
      >
        <h1 className="hdr hdr--primary hdr--lg">{doc.title}</h1>
        {doc.showDataController && (
          <>
            <h2 style={text}>Data Controller</h2>
            <p style={text}>
              The data controller responsible for your personal information collected through this Service is:
            </p>
            <p style={text}>
              <strong>{entity.name}</strong><br />
              {entity.addressLines.map((line) => (
                <React.Fragment key={line}>{line}<br /></React.Fragment>
              ))}
              <br />
              Email: {entity.email}
            </p>
          </>
        )}
        <p style={text}>
          <strong>Effective Date:</strong> {doc.effectiveDate}
        </p>

        {doc.intro.map((para, i) => (
          <p key={i} style={text}><Segments content={para} /></p>
        ))}

        {doc.sections.map((section, i) => (
          <Section key={section.title} section={section} num={i + 1} />
        ))}
      </div>

      {!hideFooter && (
        <AppFooter
          buttons={[
            {
              icon: <FaArrowLeft />,
              label: "Back",
              onClick: () => navigate(-1),
            },
          ]}
        />
      )}
    </>
  );
}

export default LegalDocument;
